import {takeEvery} from 'redux-saga/effects'
import {
  GET_GRADEWISE_COMMENTS,
  SAVE_GRADEWISE_COMMENTS,
} from 'setup/redux/Actions/GradewiseComments/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_GRADEWISE_COMMENTS, fetchData)
  yield takeEvery(SAVE_GRADEWISE_COMMENTS, fetchData)
}

export default dataSaga
